import React from 'react';
import BankContract from '@src/pages/ticketShared/BankContract';

const Wrapper = () => <BankContract containerClass="autoUploadInstructions-bank-contract" />;

export default Wrapper;
